import { H3, Navbar, NavbarGroup } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router';
import styles from 'Styles/styles.module.css';
import AppContentView from '../AppContentView';

const LandingPageWithLinks = ({
  landingTitle = '',
  pageTitle = '',
  titleButton,
  breadcrumbs,
  links,
  children,
}) => {
  let landingHeader = (
    <Navbar>
      <NavbarGroup>
        <H3 style={{ marginTop: 16, marginBottom: 12 }}>{landingTitle}</H3>
      </NavbarGroup>
      <NavbarGroup align='right'>
        {links.map((link, index) => {
          return (
            <NavLink
              key={index}
              to={link.to}
              className={({ isActive }) =>
                isActive ? styles.nav_button_selected : styles.nav_button
              }
              style={{ marginLeft: 2, marginRight: 2 }}
              onMouseDown={(e) => e.preventDefault()}>
              {link.text}
            </NavLink>
          );
        })}
      </NavbarGroup>
    </Navbar>
  );

  return (
    <AppContentView
      breadcrumbs={breadcrumbs}
      hideBreadcrumbs={!breadcrumbs?.length}
      header={landingHeader}
      title={pageTitle}
      titleButton={titleButton}>
      {children}
    </AppContentView>
  );
};

LandingPageWithLinks.propTypes = {
  landingTitle: PropTypes.string,
  pageTitle: PropTypes.string,
  titleButton: PropTypes.node,
  breadcrumbs: PropTypes.array,
  links: PropTypes.array,
  children: PropTypes.node,
};

export default LandingPageWithLinks;
